import { Component, OnInit,Input } from '@angular/core';
import { HttpclientService } from '../../services/httpclient.service';
import { Usertypeandaccessdto } from '../../model/usertypeandaccessdto';
import { Savingcreateuser } from '../../model/savingcreateuser';
import { Enablesaveuseraccessdto } from '../../model/enablesaveuseraccessdto';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-admin-cr-btn',
  templateUrl: './user-admin-cr-btn.component.html',
  styleUrls: ['./user-admin-cr-btn.component.css']
})
export class UserAdminCrBtnComponent implements OnInit {
  @Input()  createuser : boolean;
  selectPartenerLocations: any[] = [];
  usertypeandaccessdto : Usertypeandaccessdto;
  roleList : Role[];
  partnerList : Partner[];
 
  selectedLevelusertype : string;
  selectedLevelaccess : string;
  accessValue : string;
  modalPopup : boolean=false;
  modalLocPopup : boolean=false;
  location_name="";
  data;
  distributorSavedLocation=[];
  updateLocationList = [];
  updatedSelectedLocations = [    
  ];

  selectedlocations: any = [];
  selectedlocationsLeftPanel: any = [];
  savingcreateuser: Savingcreateuser;
  isUserCreated : Enablesaveuseraccessdto;
  isvalidated : string = "";
  isSaved : string ="";
  isEmailAddressExists : string ="";
  confirmPasswordchecck : string;
  loading: boolean;
  checkingField : string="";
  checkingDotForEmailModel : string="";
  dotValidation:string;
  constructor(private httpclientService : HttpclientService,private router: Router) { }

  ngOnInit() {
    this.getusertypeNaccess();
  }
  checkingDotForEmail(){
    this.dotValidation="";
    var isHas = this.checkingDotForEmailModel.includes(".");
    if(isHas==false){
      this.dotValidation="Please Enter valid Email Address";
    }
  }
  isEmailValid:boolean=false;
  checkingEmail(email){
    var emailCheck = email.value;
    var isEmailValid="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$";
    if(!emailCheck.match(isEmailValid)){
      this.isEmailValid=true;
    }else{
      this.isEmailValid=false;
    }
  }
  clearmessage(){
    
    this.nameCheck="";
    this.emialCheck="";
    this.userTypeCheck="";
    this.accessCheck="";
    this.passwordCheck="";
    this.confPassCheck="";
    this.matchPassCheck="";
    this.isValidatedFields="";
   
  }
  pressingLocationModalOK(){
    this.modalLocPopup=false;        
  }
  pressingOK(){
    this.modalPopup=false;
    this.router.navigate(['user admin']);

  }
  pressingCancel(){
    this.modalPopup=false;
  }
  nameCheck:string="";
  emialCheck:string="";
  userTypeCheck:string="";
  accessCheck:string="";
  passwordCheck:string="";
  confPassCheck:string="";
  matchPassCheck:string="";
  isValidatedFields : string="";
  savecreateduser(firstName,lastName,emailAddress,selectedLevelusertype,selectedLevelaccess,password,confirmPassword){
    this.isValidatedFields="";
    this.isSaved="";
    this.isEmailAddressExists="";
    this.isEmailValid=false;
    if(
      (firstName.value == "" || firstName.value  == undefined || firstName.value  == null) && 
      (emailAddress.value == "" || emailAddress.value == undefined || emailAddress.value == null) &&
      (selectedLevelusertype.value == "" || selectedLevelusertype.value == undefined || selectedLevelusertype.value == null) &&
      (password.value == "" || password.value == undefined || password.value == null) &&
      (confirmPassword.value == "" || confirmPassword.value == undefined || confirmPassword.value == null)
    ){
      this.nameCheck="Please Enter First Name";
      this.emialCheck="Please Enter Email Address";
      this.userTypeCheck="Please Select User Type";
      this.passwordCheck="Please Enter Password";
      this.confPassCheck="Please Enter Confirm Password";
      this.isValidatedFields="All mandatory fields need to be filled. Please check details below.";
    }
    if(firstName.value == "" || firstName.value  == undefined || firstName.value  == null){
     this.nameCheck="Please Enter First Name";
     this.isValidatedFields="All mandatory fields need to be filled. Please check details below.";
      return ;
    }
   
    if(emailAddress.value == "" || emailAddress.value == undefined || emailAddress.value == null){
      this.emialCheck="Please Enter Email Address";
      this.isValidatedFields="All mandatory fields need to be filled. Please check details below.";
      return ;
    }
    if(!emailAddress.value.includes("@")){
      this.emialCheck="Please Enter Email Address In Proper Format";
      this.isValidatedFields="All mandatory fields need to be filled. Please check details below.";
      return;
    }
    if(!emailAddress.value.includes(".")){
      this.emialCheck="Please Enter Email Address In Proper Format";
      return;
    }
    if(emailAddress.value.includes(".") && emailAddress.value.includes("@")){
     var pos1  =  emailAddress.value.lastIndexOf("@")+3; 
      var pos2 = emailAddress.value.lastIndexOf(".")
      var size = emailAddress.value.length-1;
      if(pos2 < pos1){
      this.emialCheck="Please Enter Email Address In Proper Format";
      this.isValidatedFields="All mandatory fields need to be filled. Please check details below.";
      return;
      }
      if(size <= pos2){
        this.emialCheck="Please Enter Email Address In Proper Format";
        this.isValidatedFields="All mandatory fields need to be filled. Please check details below.";
        return;
      }
    }
    if(selectedLevelusertype.value == "" || selectedLevelusertype.value == undefined || selectedLevelusertype.value == null){
      this.userTypeCheck="Please Select User Type";
      this.isValidatedFields="All mandatory fields need to be filled. Please check details below.";
      return ;
    }
    // if(selectedLevelaccess.value == "" || selectedLevelaccess.value == undefined || selectedLevelaccess.value == null){
    //   this.loading=false;
    //   return ;
    // }
    if(selectedLevelusertype.value =="3" && (selectedLevelaccess.value=="" || selectedLevelaccess.value==undefined || selectedLevelaccess.value==null)){
      this.accessCheck="Please Select Access";
      this.isValidatedFields="All mandatory fields need to be filled. Please check details below.";
      return ;
    }
    if(password.value == "" || password.value == undefined || password.value == null){
      this.passwordCheck="Please Enter Password";
      this.isValidatedFields="All mandatory fields need to be filled. Please check details below.";
      return ;
    }
    if(password.value.length < 8 ){
      this.passwordCheck="The Password must be of minimum 8 characters length";
      this.isValidatedFields="All mandatory fields need to be filled. Please check details below.";
      return ;
    }
    if(confirmPassword.value == "" || confirmPassword.value == undefined || confirmPassword.value == null){
      this.confPassCheck="Please Enter Confirm Password";
      this.isValidatedFields="All mandatory fields need to be filled. Please check details below.";
      return ;
    }
    if(confirmPassword.value.length < 8 ){
      this.confPassCheck="The Confirm Password must be of minimum 8 characters length";
      this.isValidatedFields="All mandatory fields need to be filled. Please check details below.";
      return ;
    }
    if(password.value != confirmPassword.value){
      this.matchPassCheck="Password and Confirm Password must match";
      this.isValidatedFields="All mandatory fields need to be filled. Please check details below.";
      return ;
    }
    this.createuser=true;
    this.savingcreateuser = new Savingcreateuser(firstName.value,lastName.value,emailAddress.value,selectedLevelusertype.value.toLowerCase(),
    selectedLevelaccess.value,password.value,this.selectedlocations);

      this.loading=true;
      this.httpclientService.savecreateduser(this.savingcreateuser).subscribe(
        data=>{
          this.isSaved=data.isSaved;
          this.isEmailAddressExists=data.isEmailAddressExists;
          this.loading=false;
         
        }
      );
    
    
  }

  getusertypeNaccess(){
    this.loading=true;
    this.httpclientService.getusertypeNaccess().subscribe(
      data=>{
        this.usertypeandaccessdto=data;
        var len = this.usertypeandaccessdto.roleList.length;
        for(var i=0;i<len; i++){
          var roleListType = this.usertypeandaccessdto.roleList[i].roleType;
          this.usertypeandaccessdto.roleList[i].roleType = roleListType[0].toUpperCase() + roleListType.slice(1);
          
        }
        
        this.loading=false;
        this.roleList = this.usertypeandaccessdto.roleList.sort(function (a, b) {
          return a.roleType.localeCompare(b.roleType);
        });

        const sortOn = (prop, list) => {
          const order = list.reduce((obj, key, idx) => Object.assign(obj, { [key]: idx + 1}), {});
          const getVal = item => order[item[prop]] || Infinity
          
          return (a, b) => getVal(a) - getVal(b)
        }
        
        this.roleList.sort(sortOn('roleType', ["Admin", "Axalta Admin", "Axalta CSR", "Distributor", "Customer"]))
        
        this.partnerList = this.usertypeandaccessdto.partnerList.sort(function (a, b) {
          return a.partnerType.localeCompare(b.partnerType);
        });
      }
    );   
  }

  selectedusertype(usert){
    console.log(usert.value);
    this.selectedLevelusertype;
   
  }
  
  comparepassword(passwordcheck){
    alert(passwordcheck);
  }
  cancelcreateuser(){
    this.isSaved="";
    this.isEmailAddressExists="";
    this.checkingField="";
    this.modalPopup=true;
    
  }
  
  moveStoreToLeft(): void 
  {
    let value = (<HTMLSelectElement>document.getElementById('leftPanel')).value;
    var ID = value.substring(0,value.indexOf(":"));
    var response1 = value.substring(value.indexOf(":")+3, value.length-1);
  
    for(let j = 0; j < this.selectPartenerLocations.length; j++){
      var response = this.selectPartenerLocations[j].substring(this.selectPartenerLocations[j].indexOf(":")+1, this.selectPartenerLocations[j].length);
        for(let i = 0; i < this.data.length; i++)
        {
           if(this.data[i].name === response)
           {       
             //this.selectedLocations.push({id:this.data[i].id, name:this.data[i].name});
             this.selectedlocations.push(this.data[i]);
           }
           else{
            //this.updateLocationList.push({id:this.data[i].id, name:this.data[i].name})
            this.updateLocationList.push(this.data[i])
           }
        }
  
        this.data = this.updateLocationList;
        this.updateLocationList = [];
    }

    this.selectPartenerLocations = [];
  }
  
  moveStoreToRight(): void 
  {

    for(let j = 0; j < this.selectPartenerLocations.length; j++){

      var response = this.selectPartenerLocations[j].substring(this.selectPartenerLocations[j].indexOf(":")+1, this.selectPartenerLocations[j].length); 

    let isLocationFoundInList = true;
    let value = (<HTMLSelectElement>document.getElementById('rightPanel')).value;
    
    //var response = value.substring(value.indexOf(":")+3, value.length-1);
  
    var partnerId = value.substring(0,value.indexOf(":"));
    // console.log("---------------------------------------------------------");
    let selectedPartnerId :String="";
    //alert("this.selectedlocations.length : " + this.selectedlocations)
    for(let i = 0; i < this.selectedlocations.length; i++)
    {  
      if(this.selectedlocations[i].name === response)
      {
        selectedPartnerId = this.selectedlocations[i].accessID;
        break;
      }
    }
  
    //alert("selectedPartnerId : " + selectedPartnerId);
    //alert("this.accessValue " + this.accessValue )
  
    if(selectedPartnerId != this.accessValue)
    {
      isLocationFoundInList = false;   
    }
  
    if(isLocationFoundInList)
    {
     // alert("isLocationFoundInList : " + isLocationFoundInList)
      for(let i = 0; i < this.selectedlocations.length; i++)
      {
     
       if(this.selectedlocations[i].name === response)
       {
         
         //this.data.push({id:this.selectedlocations[i].id, name:this.selectedlocations[i].name});
         this.data.push(this.selectedlocations[i]);
       }
       else{
        //this.updatedSelectedLocations.push({id:this.selectedLocations[i].id, name:this.selectedLocations[i].name});
        this.updatedSelectedLocations.push(this.selectedlocations[i]);
       }
      }
  
  
    this.selectedlocations = this.updatedSelectedLocations;
    this.updatedSelectedLocations = [];
    }
    else
    {
      this.modalLocPopup = true;
    }
    }
    this.selectPartenerLocations = [];
  }

getDistributorLocationDetails(){      
  this.data = [];
  
  if(this.accessValue=="" || this.accessValue== null || this.accessValue== undefined){
     this.data = [];
  }
  else
  {
    this.loading=true;
    this.httpclientService.getDistributorLocationDetails(this.accessValue,null).subscribe(
      data =>{        
        this.data = data;         
      }      
    )
    this.loading=false;
  }  
}

selectChangeHandler(event: any): void { 
  if(event.target.value === '')
  {
    this.selectedlocations = [];
    this.data = [];
  }
  else
  {
    this.accessValue = event.target.value;
    this.getDistributorLocationDetails();
  }  
}

}

class Role{
  public roleId : number;
  public roleType : string;
  constructor(
       roleId ,
       roleType 
  ){
      this.roleId=roleId;
      this.roleType=roleType;
  }

}
class Partner{
  public partnerId : number;
  public partnerType : string;

  constructor(
       partnerId ,
       partnerType ,
  ){
      this.partnerId=partnerId;
      this.partnerType=partnerType;
  }

}
